/* Mobile-only fixed bar for ATC + BIS on PDP. */
(function () {
  'use strict';
  const MQ = window.matchMedia('(max-width: 798px)');
  const STICKY_CLASS = 'product-mobile-sticky--active';
  const SOON_BIS_CLASS = 'product-mobile-sticky--soon-bis';
  const ADDED_CLASS = 'product-mobile-sticky--atc-added';
  const CSS_VAR_ATC_H = '--product-sticky-atc-h';
  const CSS_VAR_BIS_H = '--product-sticky-bis-h';
  const CSS_VAR_VV_INSET = '--product-sticky-chrome-vv-inset';
  const CSS_VAR_STACK_CLEARANCE = '--product-sticky-stack-clearance';
  let pendingHideAfterPdpAtc;
  let root;
  let ro;
  let mo;
  let bodyMo;
  let vvHandlerBound;
  let windowScrollHandler;
  let windowScrollBound;
  let windowScrollRaf;

  function isMobile() {
    return MQ.matches;
  }

  function visible(el) {
    if (!el) return false;
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    return el.getBoundingClientRect().height > 0;
  }

  function normalizeLabel(s) {
    return String(s || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }


  function isComingSoonSticky() {
    if (!root) return false;
    var tr = window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.coming_soon;
    if (!tr) return false;
    var btn = root.querySelector('[data-add-to-cart-trigger]');
    if (!btn || !btn.hasAttribute('disabled')) return false;
    var textEl = btn.querySelector('.text');
    var label = (textEl && textEl.textContent) || btn.textContent || '';
    return normalizeLabel(label) === normalizeLabel(tr);
  }

  function syncSoonBisClass() {
    if (!root || !document.body.classList.contains(STICKY_CLASS)) return;
    document.body.classList.toggle(SOON_BIS_CLASS, isComingSoonSticky());
  }

  function unwrapBisForSticky() {
    var bis = document.getElementById('BIS_trigger');
    if (!bis || typeof bis._bisStickyRestore !== 'function') return;
    bis._bisStickyRestore();
    bis._bisStickyRestore = null;
  }


  function shouldWrapBisInSticky() {
    var bis = document.getElementById('BIS_trigger');
    if (!bis || !visible(bis)) return false;
    if (!root) return false;
    var atc = root.querySelector('[data-add-to-cart-trigger]');
    if (!atc) return true;
    var blocked = atc.hasAttribute('disabled') || atc.classList.contains('disabled');
    if (!blocked) return false;
    return true;
  }

  function wrapBisForSticky() {
    if (!root || !document.body.classList.contains(STICKY_CLASS)) return;
    if (!shouldWrapBisInSticky()) {
      unwrapBisForSticky();
      return;
    }
    var bis = document.getElementById('BIS_trigger');
    if (!bis || bis.closest('.product-mobile-sticky-bis-slot')) return;

    var slot = document.createElement('div');
    slot.className = 'product-mobile-sticky-bis-slot';
    var origParent = bis.parentNode;
    var origNext = bis.nextSibling;

    bis.dataset.bisStickyOriginalClass = bis.className;
    bis.classList.remove('button--add-to-cart');
    bis.classList.add('button', 'button--secondary', 'action_button', 'action_button--secondary');
    if (!bis.classList.contains('button--cta')) bis.classList.add('button--cta');

    root.appendChild(slot);
    slot.appendChild(bis);

    bis._bisStickyRestore = function () {
      bis.className = bis.dataset.bisStickyOriginalClass || bis.className;
      delete bis.dataset.bisStickyOriginalClass;
      if (origParent) {
        try {
          if (origNext && origNext.parentNode === origParent) origParent.insertBefore(bis, origNext);
          else origParent.appendChild(bis);
        } catch (e) {
          origParent.appendChild(bis);
        }
      }
      if (slot.parentNode) slot.remove();
    };
  }

  function syncChromeVisualViewportInset() {
    var vv = window.visualViewport;
    if (!vv) {
      document.documentElement.style.removeProperty(CSS_VAR_VV_INSET);
      return;
    }
    var layoutH = window.innerHeight;
    var inset = Math.max(0, layoutH - vv.offsetTop - vv.height);
    document.documentElement.style.setProperty(CSS_VAR_VV_INSET, inset + 'px');
  }

  function bindWindowScrollForChromeVv() {
    if (windowScrollBound) return;
    windowScrollBound = true;
    windowScrollHandler = function () {
      if (!document.body.classList.contains(STICKY_CLASS)) return;
      if (windowScrollRaf) return;
      windowScrollRaf = requestAnimationFrame(function () {
        windowScrollRaf = 0;
        scheduleMetrics();
      });
    };
    window.addEventListener('scroll', windowScrollHandler, { passive: true });
    window.addEventListener('resize', windowScrollHandler, { passive: true });
    window.addEventListener('orientationchange', windowScrollHandler, { passive: true });
  }

  function unbindWindowScrollForChromeVv() {
    if (!windowScrollBound || !windowScrollHandler) return;
    window.removeEventListener('scroll', windowScrollHandler);
    window.removeEventListener('resize', windowScrollHandler);
    window.removeEventListener('orientationchange', windowScrollHandler);
    windowScrollBound = false;
    windowScrollHandler = null;
  }

  function clearStickyCssVars() {
    document.documentElement.style.removeProperty(CSS_VAR_ATC_H);
    document.documentElement.style.removeProperty(CSS_VAR_BIS_H);
    document.documentElement.style.removeProperty(CSS_VAR_VV_INSET);
    document.documentElement.style.removeProperty(CSS_VAR_STACK_CLEARANCE);
  }

  function clearFloatingPromoOffsets() {
    document.querySelectorAll('[data-product-sticky-cta-offset="1"]').forEach(function (el) {
      el.style.removeProperty('bottom');
      el.removeAttribute('data-product-sticky-cta-offset');
    });
  }


  function applyFloatingPromoOffsets() {
    clearFloatingPromoOffsets();
    if (!document.body.classList.contains(STICKY_CLASS)) return;
    var clearance = document.documentElement.style.getPropertyValue(CSS_VAR_STACK_CLEARANCE);
    if (!clearance || clearance === '0px') return;
    var bottomVal = 'calc(' + clearance.trim() + ' + 8px)';

    var seen = new WeakSet();
    function tryApply(el) {
      if (!el || el === document.body || seen.has(el)) return;
      if (el.closest && el.closest('[data-product-mobile-cta-root]')) return;
      if (el.closest && el.closest('.ajax-cart')) return;
      if (el.closest && el.closest('.mobile-menu')) return;
      if (el.closest && el.closest('#CookiebotWidget')) return;
      var s = window.getComputedStyle(el);
      if (s.position !== 'fixed') return;
      if (s.display === 'none' || s.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height < 10 || r.width < 10) return;
      var ih = window.innerHeight;
      var iw = window.innerWidth;
      if (ih - r.bottom > 48) return;
      if (r.width > iw * 0.92) return;
      if (r.height > ih * 0.55) return;
      if (r.left > iw * 0.62) return;
      seen.add(el);
      el.style.setProperty('bottom', bottomVal, 'important');
      el.setAttribute('data-product-sticky-cta-offset', '1');
    }

    var id = document.getElementById('triggerbee-join-the-fanclub-id');
    var idBtn = document.getElementById('triggerbee-join-the-fanclub-button-id');
    var hints = document.querySelectorAll(
      '[id^="triggerbee"], [class*="triggerbee"], [id^="smile"], [class*="smile-launcher"], [data-tb-widget], [class*="tb-"]'
    );
    for (var h = 0; h < hints.length; h++) {
      var n = hints[h];
      if (n === id || n === idBtn) continue;
      var el = n;
      while (el && el !== document.body) {
        if (window.getComputedStyle(el).position === 'fixed') {
          tryApply(el);
          break;
        }
        el = el.parentElement;
      }
    }

    var visited = 0;
    var maxVisit = 900;
    function walk(el, depth) {
      if (!el || depth > 14 || visited >= maxVisit) return;
      visited++;
      var s = window.getComputedStyle(el);
      if (s.position === 'fixed') {
        tryApply(el);
        return;
      }
      var ch = el.children;
      for (var i = 0; i < ch.length; i++) walk(ch[i], depth + 1);
    }
    for (var b = 0; b < document.body.children.length; b++) walk(document.body.children[b], 0);
  }

  function refreshStickyLayout() {
    wrapBisForSticky();
    updateMetrics();
  }

  function updateMetrics() {
    if (!root || !document.body.classList.contains(STICKY_CLASS)) return;
    syncChromeVisualViewportInset();
    syncSoonBisClass();
    var isSoonBis = document.body.classList.contains(SOON_BIS_CLASS);
    var buttons = root.querySelector('.purchase-details__buttons');
    var notify = root.querySelector('[id^="notify-form-"]');
    var bisSlot = root.querySelector('.product-mobile-sticky-bis-slot');
    var bh = isSoonBis ? 0 : buttons && visible(buttons) ? buttons.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty(CSS_VAR_ATC_H, bh + 'px');
    var bisH = bisSlot && visible(bisSlot) ? bisSlot.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty(CSS_VAR_BIS_H, bisH + 'px');
    var nh = notify && visible(notify) ? notify.getBoundingClientRect().height : 0;
    var betweenStrips = bisH > 0 && bh > 0 ? 8 : 0;
    document.body.style.paddingBottom = bh + betweenStrips + bisH + nh + 2 + 'px';

    var vvStr = document.documentElement.style.getPropertyValue(CSS_VAR_VV_INSET) || '';
    var vvNum = parseFloat(vvStr) || 0;
    var stackClearance = vvNum + bh + betweenStrips + bisH;
    document.documentElement.style.setProperty(CSS_VAR_STACK_CLEARANCE, stackClearance + 'px');
    applyFloatingPromoOffsets();
  }

  function scheduleMetrics() {
    updateMetrics();
    requestAnimationFrame(updateMetrics);
  }

  function teardown() {
    unwrapBisForSticky();
    document.body.classList.remove(STICKY_CLASS);
    document.body.classList.remove(SOON_BIS_CLASS);
    document.body.classList.remove(ADDED_CLASS);
    pendingHideAfterPdpAtc = false;
    document.body.style.paddingBottom = '';
    clearFloatingPromoOffsets();
    clearStickyCssVars();
    root = null;
    if (ro) {
      ro.disconnect();
      ro = null;
    }
    if (mo) {
      mo.disconnect();
      mo = null;
    }
    if (bodyMo) {
      bodyMo.disconnect();
      bodyMo = null;
    }
    if (vvHandlerBound && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', vvHandlerBound);
      window.visualViewport.removeEventListener('scroll', vvHandlerBound);
      vvHandlerBound = null;
    }
    unbindWindowScrollForChromeVv();
  }

  function apply() {
    if (!isMobile()) {
      teardown();
      return;
    }
    root = document.querySelector('[data-product-mobile-cta-root]');
    if (!root) {
      teardown();
      return;
    }
    document.body.classList.add(STICKY_CLASS);
    var cartDrawerEl = document.getElementById('theme-ajax-cart');
    if (cartDrawerEl && cartDrawerEl.classList.contains('is-visible')) {
      document.body.classList.add(ADDED_CLASS);
      scheduleMetrics();
    }
    var cookiebotWidget = document.getElementById('CookiebotWidget');
    if (cookiebotWidget && cookiebotWidget.getAttribute('data-product-sticky-cta-offset') === '1') {
      cookiebotWidget.style.removeProperty('bottom');
      cookiebotWidget.removeAttribute('data-product-sticky-cta-offset');
    }
    syncSoonBisClass();
    wrapBisForSticky();
    scheduleMetrics();
    setTimeout(wrapBisForSticky, 0);
    setTimeout(wrapBisForSticky, 400);
    if (ro) ro.disconnect();
    ro = new ResizeObserver(refreshStickyLayout);
    ro.observe(root);
    if (mo) mo.disconnect();
    mo = new MutationObserver(refreshStickyLayout);
    mo.observe(root, {
      attributes: true,
      subtree: true,
      attributeFilter: ['style', 'class', 'disabled'],
      childList: true,
    });
    if (bodyMo) bodyMo.disconnect();
    var bisMoTimer;
    bodyMo = new MutationObserver(function () {
      clearTimeout(bisMoTimer);
      bisMoTimer = setTimeout(refreshStickyLayout, 60);
    });
    bodyMo.observe(document.body, { childList: true, subtree: true });
    if (window.visualViewport && !vvHandlerBound) {
      vvHandlerBound = function () {
        scheduleMetrics();
      };
      window.visualViewport.addEventListener('resize', vvHandlerBound);
      window.visualViewport.addEventListener('scroll', vvHandlerBound);
    }
    bindWindowScrollForChromeVv();
  }

  function onResize() {
    apply();
  }

  var didBindPostAddBehavior = false;
  function bindPostAddToCartHide() {
    if (didBindPostAddBehavior) return;
    didBindPostAddBehavior = true;

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('.ajax-submit');
        if (!btn || !document.body.classList.contains(STICKY_CLASS)) return;
        var form = btn.closest('form');
        var rootEl = document.querySelector('[data-product-mobile-cta-root]');
        if (!form || !rootEl || !rootEl.contains(form)) return;
        pendingHideAfterPdpAtc = true;
      },
      true
    );

    document.addEventListener('variant-change', function () {
      if (!document.body.classList.contains(STICKY_CLASS)) return;
      document.body.classList.remove(ADDED_CLASS);
      scheduleMetrics();
    });

    function revealStickyAfterCartDismiss() {
      if (!document.body.classList.contains(STICKY_CLASS) || !document.body.classList.contains(ADDED_CLASS)) return;
      document.body.classList.remove(ADDED_CLASS);
      scheduleMetrics();
    }

    document.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest('[data-ajax-cart-close]')) return;
        revealStickyAfterCartDismiss();
      },
      true
    );

    document.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape' && e.which !== 27) return;
      if (!document.querySelector('.ajax-cart__overlay.is-visible')) return;
      window.setTimeout(revealStickyAfterCartDismiss, 0);
    });

    if (window.jQuery) {
      window.jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        var url = (settings && settings.url) || '';
        if (url.indexOf('/cart/add.js') === -1) return;
        if (!document.body.classList.contains(STICKY_CLASS) || !pendingHideAfterPdpAtc) return;
        pendingHideAfterPdpAtc = false;
        document.body.classList.add(ADDED_CLASS);
        scheduleMetrics();
      });
      window.jQuery(document).ajaxError(function (event, xhr, settings) {
        var url = (settings && settings.url) || '';
        if (url.indexOf('/cart/add.js') === -1) return;
        pendingHideAfterPdpAtc = false;
      });
    }

    var ajaxCartDrawerStickyMo;
    function bindAjaxCartDrawerStickySync() {
      if (ajaxCartDrawerStickyMo) return;
      var cartRoot = document.getElementById('theme-ajax-cart');
      if (!cartRoot) return;
      function syncStickyForDrawer() {
        if (!document.body.classList.contains(STICKY_CLASS)) return;
        if (cartRoot.classList.contains('is-visible')) {
          document.body.classList.add(ADDED_CLASS);
          scheduleMetrics();
        } else {
          revealStickyAfterCartDismiss();
        }
      }
      ajaxCartDrawerStickyMo = new MutationObserver(syncStickyForDrawer);
      ajaxCartDrawerStickyMo.observe(cartRoot, { attributes: true, attributeFilter: ['class'] });
      syncStickyForDrawer();
    }
    bindAjaxCartDrawerStickySync();
  }

  function init() {
    bindPostAddToCartHide();
    apply();
  }

  if (!window._productStickyCtaResizeBound) {
    window._productStickyCtaResizeBound = true;
    window.addEventListener('resize', function () {
      clearTimeout(init._t);
      init._t = setTimeout(onResize, 120);
    });
    if (MQ.addEventListener) MQ.addEventListener('change', onResize);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && document.body.classList.contains(STICKY_CLASS)) {
        scheduleMetrics();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
